// extracted by mini-css-extract-plugin
export default {"container":"survey-document_container__1WzAS","survey":"survey-document_survey__33l5F","loading":"survey-document_loading__3ftGT"};